import {call, METHODS} from '../http-client';
import rules from '../../rbac-rules';

const ROUTE_PREFIX = 'roles';

export const getRoles = async () => {
    try {
        return await call(METHODS.GET, ROUTE_PREFIX, '');
    } catch (e) {
        console.error(`getRole error: ${e}`);
        throw e;
    }
}

const checkStaticPermission = (roleName, action, data) => {
    if (roleName === 'POWER_USER') {
        return true;
    }

    if (!roleName) {
        return false;
    }

    const permissions = rules[roleName.toLowerCase()];
    if (!permissions) {
        return false;
    }

    const staticPermissions = permissions.static;
    if (staticPermissions && staticPermissions.includes(action)) {
        return true;
    }

    const dynamicPermissions = permissions.dynamic;
    if (dynamicPermissions) {
        const permissionCondition = dynamicPermissions[action];
        if (!permissionCondition) {
            return false;
        }

        return permissionCondition(data);
    }

    return false;
}

export const can = (user, action, resource) => {
    const roleName = user?.provider?.role?.name;
    if (roleName === 'POWER_USER') {
        return true
    }

    const isLoggedInOwnScope = user?.loginContext?.type === 'OWN_SCOPE';
    if (isLoggedInOwnScope) {
        const permissions = [
            { action: 'READ', resource: 'metric'},
            { action: 'READ', resource: 'settings'},
            { action: 'READ', resource: 'settings:point-of-sale'},
            { action: 'READ', resource: 'settings:platform'},
            { action: 'READ', resource: 'settings:hour'},
            { action: 'READ', resource: 'settings:billing'},
        ];

        return permissions.some(p => p.resource === resource && p.action === action)
    }

    const staticCheck = (action === 'STATIC' && resource)
        ? checkStaticPermission(roleName, resource)
        : true

    const permissionsList = Array.isArray(user?.provider?.role?.permissions) ? user.provider.role.permissions : []
    const roleCheck = (action !== 'STATIC' && resource)
        ? permissionsList.some(permission => permission.action === action && permission.resource === resource)
        : true

    return staticCheck && roleCheck
}
